module.exports = __webpack_public_path__ + "img/dat01.2437c358.png";